import TYPES from '@/modules/shared/types';

// Domain
import { AllianzCustomerAvailableBalanceRepository } from '../../domain/repository';
import { AllianzCustomerAvailableBalanceEntity } from '../../domain/entities/allianz-customer-available-balance-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class AllianzCustomerAvailableBalanceHttpRepository
implements AllianzCustomerAvailableBalanceRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/customer-available-balance/`;

  execute(fund_code: string): Promise<AllianzCustomerAvailableBalanceEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}?fund_code=${fund_code}`)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
